export const UPDATE_VEHICLES = 'UPDATE_VEHICLES';

interface UpdateVehicles {
  type: typeof UPDATE_VEHICLES;
  payload: [];
}

export type VehiclesInfoActionTypes = UpdateVehicles;
